import { render, staticRenderFns } from "./CustomerPropertiesDropdown.vue?vue&type=template&id=178e8495&scoped=true&"
import script from "./CustomerPropertiesDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerPropertiesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPropertiesDropdown.vue?vue&type=style&index=0&id=178e8495&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e8495",
  null
  
)

export default component.exports